// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Dd","articleImagesWrap":"Ed","articleImage":"Fd","singleImage":"Gd"};